<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<app-scenario-list class="background" fxFill fxLayout="row" fxLayoutAlign="center start"
  [isLoading]="loading$ | async" [scenarioList]="scenarios$ | async" [statuses]="statuses | async" [adminMode]="true"
  [views]="viewList | async" (saveScenario)="saveScenario($event)">
</app-scenario-list>
